export const lineHeights = {
  slim: '110%',
  shortest: '115%',
  shorter: '120%',
  short: '125%',
  shortbase: '130%',
  base: '150%',
  tall: '160%',
}